import { render, staticRenderFns } from "./CanvasAiPanel.vue?vue&type=template&id=2c7b89dd&scoped=true&"
import script from "./CanvasAiPanel.vue?vue&type=script&lang=js&"
export * from "./CanvasAiPanel.vue?vue&type=script&lang=js&"
import style0 from "./CanvasAiPanel.vue?vue&type=style&index=0&id=2c7b89dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b89dd",
  null
  
)

export default component.exports